import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Label, LabelList } from 'recharts';
import { BarChart, Bar, Cell, ResponsiveContainer, Brush, ReferenceLine } from 'recharts';
const StudentBarChart = ({group}) => {
  if(!group || ( Number(group.response?.length) + Number(group.userQuestionSet?.length) ) ===0) return <></>
  const colors ={
    task:"#8884d8",
    question:"#82ca9d"
  }
  const responseList = group.responses.map((response) => {
    return {
      grade: response.grade<0?0:  response.grade,
      title: response.relatedTask?.title,
      type:"משימה",
      color:colors.task
    }
  })
  const questionList = group.userQuestionSet.map((question) => {
    return {
      grade: question.totalScore>0? 100 : question.totalScore,
      title:question.questionSetTitle,
      type:"שאלון",
      color:colors.question
    }
  })
  const data =[...responseList,...questionList]
  const renderColorfulLegendText = (value, entry) => {
    const taskText = responseList.length?<>  <span style={{background: colors.task}}>&nbsp;</span> <span style={{ color: colors.task }}>משימה</span></> :<></>
    const questionText = questionList.length?<>  <span style={{background: colors.question}}>&nbsp;</span> <span style={{ color: colors.question }}>שאלון</span></> :<></>
      return <> {taskText}{questionText}  </>;
  };
  if(!data.length) return <>  </>
  const average =  data.reduce((acc, curr) => acc + curr.grade, 0) /  data.length
  return (
    <>
    <h3>{group.name}</h3>
    <h4>ממוצע {average.toFixed(1)}</h4>
    <div style={{ width: "100%", height: 600, marginBottom:"60px" }}>
    <ResponsiveContainer width="100%" height="100%">
    <BarChart
  
      data={data}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5,
        
      }}
    >

      <CartesianGrid strokeDasharray="3 3" />
      <XAxis interval={0}  style={{fontSize:"13px"}} dataKey="title" height={250}    angle={-45}  tick={{ textAnchor: "start", fill:"#fff" }} >
          <Label value=""  offset={0} position="insideBottom" />
        </XAxis>
        <YAxis tick={{ dx: -20 }} style={{fontSize:"13px"}} />

    
<Tooltip 
  wrapperStyle={{ color: "black", backgroundColor: "white", border: "1px solid #ccc" }}
/>

      {/* <Legend verticalAlign="bottom" wrapperStyle={{ lineHeight: '40px', marginTop:"-20px" }} /> */}
      <Legend verticalAlign="top" wrapperStyle={{ lineHeight: '40px', marginTop:"-20px" }} formatter={renderColorfulLegendText} />
      {/* <ReferenceLine y={0} stroke="#000" /> */}

      {/* <Brush dataKey="username" height={30} stroke="#8884d8" /> */}
      <Bar dataKey="grade"  >
        <LabelList dataKey="grade" position="top"  fill="white" fontSize={10} />
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.color} />
        ))}
      </Bar>
      
      <ReferenceLine y={average} stroke="red" strokeWidth={2} strokeDasharray="5 5"  />

    </BarChart>
  </ResponsiveContainer>
  </div>
  </>
  )
}

export default StudentBarChart